export const paymentPreferences=`<p>The ability to Add/Delete/View/Approve/Reject Payment preferences via Gem Connect will be coming soon.</p>
<p>If you have previously set up payment preferences, they will continue to apply to approved payments.</p>
`;


// WEBPACK FOOTER //
// ./src/components/content/payments/18-paymentPreferences.ts